import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";

import { ContactInfoInputs } from "./components/contact-info-inputs";

export default function ContactInfoCallNow() {
  const { t } = useTranslation();

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle className="md:mt-6">
            {t("FUNNEL_CONTACT_INFO_TITLE")}
          </StepTitle>
          <StepSubtitle className="mb-8 mt-1 max-w-screen-sm">
            {t("FUNNEL_CONTACT_INFO_SUBTITLE_DEFAULT")}
          </StepSubtitle>
          <ContactInfoInputs />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
